var t = /* @__PURE__ */ ((r) => (r[r.X = 0] = "X", r[r.Y = 1] = "Y", r[r.Z = 2] = "Z", r[r.FACE = 3] = "FACE", r))(t || {});
export {
  t as AxisIndex
};
//# sourceMappingURL=CuttingPlaneController.types.mjs.map
